import { ChangeDetectionStrategy,Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';

import { ViewContextSubscription } from 'app/navigation/view-context.service';

@Component({
    selector: 'admin-selectable-subscription-element',
    templateUrl: './selectable-subscription-element.component.html',
    styleUrls: ['./selectable-subscription-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCard, MatRipple, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent]
})
export class SelectableSubscriptionElementComponent {
    @Input() subscription: ViewContextSubscription;
    @Input() lastAccessed?: number;
    @Output() selectSubscription: EventEmitter<ViewContextSubscription> = new EventEmitter<ViewContextSubscription>();

    constructor() {
    }
}
